import { useMutation } from '@tanstack/react-query'
import { fileParserApi } from '@/lib/api'
import { useToast } from './useToast'
import type { FilePreviewResult, SeparatorType } from '@/types'

interface PreviewParams {
  file: File
  separator?: SeparatorType
  fixed_positions?: number[]
  encoding?: string
}

export function useFilePreview() {
  const { toast } = useToast()

  return useMutation({
    mutationFn: async (params: PreviewParams): Promise<FilePreviewResult> => {
      const config: Record<string, unknown> = {}
      if (params.separator) config.separator = params.separator
      if (params.fixed_positions) config.fixed_positions = params.fixed_positions
      if (params.encoding) config.encoding = params.encoding

      const res = await fileParserApi.preview(params.file, config)
      return res.data as FilePreviewResult
    },
    onError: (err: unknown) => {
      const msg =
        (err as { response?: { data?: { message?: string } } })?.response?.data?.message ||
        'Ошибка чтения файла'
      toast.error(msg)
    },
  })
}
